import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const listItemAccountStyles = StyleSheet.create({
	row: {
		// flex: 0,
	},
	buttonIconIconContainer: {
		width: 50,
		height: 50,
		justifyContent: 'center',
		alignItems: 'center',
	},
	icon: {
		color: colorList.ORANGE.primary,
		fontSize: 24
	},
	employeeName: {
		fontWeight: '700',
		marginBottom: 4
	},
	domain: {
		fontSize: 12,
		color: colorList.BLACK.light
	},
})
